// Home Rework (2026-08): admin-only "preview as free tier" override. Presentation
// AND paywall-response override — see lib/api.js's request interceptor and
// backend deps.preview_free_mode. Inert for anyone who isn't an admin.
const KEY = "sc_preview_free";

export function isPreviewFreeOn() {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function setPreviewFree(on) {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
}

// Lets the toggle be flipped via a URL flag too (?preview_free=1 / =0),
// same shape as other internal preview flags in the app.
export function syncPreviewFreeFromUrl() {
  try {
    const v = new URLSearchParams(window.location.search).get("preview_free");
    if (v === "1") setPreviewFree(true);
    else if (v === "0") setPreviewFree(false);
  } catch { /* ignore */ }
}
